export class NetworkModel {
    constructor(data = {}) {
        this.id = data.id ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
        this.networkId = data.networkId ?? '';
        this.networkName = data.networkName ?? '';
        this.carrier = data.carrier ?? '';
        this.entityId = data.entityId ?? null;
        this.marketType = data.marketType ?? '';
        this.status = data.status ?? '';
    }
}